/**
 * SelectCell - the row's tick box (docs/plans/crm-recruitment-list-plan.md Part A section 4, B4,
 * decision 10): it feeds the bulk bar. A 44px target on phones; the click never opens the lead.
 */
import type { MouseEvent } from 'react';
import { contactName } from '../../../types';
import type { RecruitRow, RecruitSelectHandler } from '../../types';

export interface SelectCellProps {
  row: RecruitRow;
  /** The row is ticked. */
  selected: boolean;
  /** Tick or untick this row. */
  onSelect: RecruitSelectHandler;
  className?: string;
}

/** The shared checkbox look (the inbox's checkboxCls). */
export const CHECKBOX_CLS =
  'h-4 w-4 cursor-pointer rounded border-gray-300 text-primary-600 focus:ring-2 focus:ring-primary-500 dark:border-gray-600 dark:bg-gray-700';

const stop = (e: MouseEvent) => e.stopPropagation();

export function SelectCell({ row, selected, onSelect, className = '' }: SelectCellProps) {
  const name = contactName(row.contact);
  return (
    <label
      onClick={stop}
      className={`flex min-h-[44px] min-w-[44px] cursor-pointer items-center justify-center sm:min-h-0 sm:min-w-0 ${className}`}
    >
      <input
        type="checkbox"
        checked={selected}
        onChange={(e) => onSelect(row.contact.id, e.target.checked)}
        aria-label={`Select ${name}`}
        className={CHECKBOX_CLS}
      />
    </label>
  );
}

export default SelectCell;
